import { ECategoryFile, ICategoryScreenRender, TProductFlagsKey } from '@features/categories/typescript';
import { BASE_PATH } from '@config/index';
export const PRODUCT_CARD_DEFAULT_COL_WIDTH = {
  ultrahd: 6,
  fullhd: 6,
  widescreen: 6,
  desktop: 6,
  tabletlg: 8,
  tablet: 8,
  mobilelg: 12,
  mobile: 12
};
export const PRODUCT_CARD_RENDER_ROW_COUNT: ICategoryScreenRender<number> = {
  ultrahd: 4,
  fullhd: 4,
  widescreen: 4,
  desktop: 4,
  tabletlg: 3,
  tablet: 3,
  mobilelg: 2,
  mobile: 2
};
export const INFO_CARD_ROW_COUNT: ICategoryScreenRender<number> = {
  ultrahd: 6,
  fullhd: 6,
  widescreen: 6,
  desktop: 6,
  tabletlg: 8,
  tablet: 8,
  mobilelg: 24,
  mobile: 24
};
export const PRODUCT_CARD_PREMIUM_INDEX: ICategoryScreenRender<Array<number>> = {
  ultrahd: [4, 13, 18],
  fullhd: [4, 13, 18],
  widescreen: [4, 13, 18],
  desktop: [4, 13, 18],
  tabletlg: [3, 9, 13, 19, 23],
  tablet: [3, 9, 13, 19, 23],
  mobilelg: [2, 7, 12, 17, 22],
  mobile: [2, 7, 12, 17, 22]
};
export const PRODUCT_OBJECT_SCOPE = ['id', 'slug', 'name', 'price', 'files', 'flags', 'manufacturer', 'configurable', 'colorSwatch', 'gpsr'];
export const PRODUCT_ARRANGEMENT_PHOTO = 'PRODUCT_ARRANGEMENT';
export const PRODUCT_MAIN_PHOTO = 'PRODUCT_MAIN';
export const PRODUCT_MAIN_PHOTO_WITH_SHADOW = 'PRODUCT_MAIN_WITH_SHADOW';
export const PRODUCT_MAIN_VIDEO = 'PRODUCT_VIDEO_PACKSHOT';
export const PRODUCT_HOVER_PHOTO = 'PRODUCT_LIST_HOVER';
export const PRODUCT_LIST_VIDEO = 'PRODUCT_LIST_VIDEO';
export const PRODUCT_LIST_HOVER_OPENED_PACKSHOT = 'PRODUCT_LIST_HOVER_OPENED_PACKSHOT';
export const URL_QUERY_MAP = {
  price: 'price',
  color: 'color',
  PRODUCT_TYPE: 'product_type',
  collection: 'collection',
  designers: 'designers',
  width: 'width',
  height: 'height',
  depth: 'depth'
};
export const REQUIRED_SORT = ['price', 'availability', 'name', 'width', 'height', 'depth'];
export const PRODUCT_MAIN_PHOTO_TYPE = 'PRODUCT_MAIN_700-600';
export const NUM_OF_PACKSHOTS = 1;
export const FILTERS_NUM_TO_RENDER = {
  mobile: 0,
  mobilelg: 0,
  tablet: 2,
  tabletlg: 3,
  desktop: 3,
  widescreen: 4,
  fullhd: 4,
  ultrahd: 5
};
export const DEFAULT_CATEGORY_MAIN_IMAGE = {
  type: ECategoryFile.mainImage,
  desktop: `${BASE_PATH}/img/wizerunek-desktop.webp`,
  tablet: `${BASE_PATH}/img/wizerunek-tablet.webp`,
  mobile: `${BASE_PATH}/img/wizerunek-tablet.webp`
};
export const PRODUCTS_RENDER_COUNTS = 40;
export const SPECIAL_ITEM_POSITIONS = [4, 16, 24, 36];
type TFlagsNames = 'publication' | 'testPublication' | 'assembly' | 'novelty' | 'noveltyDate' | 'availability' | 'deliveryBehaviour' | 'hotSale' | 'hotSaleDate' | 'goodSale' | 'surpriseSale' | 'bestseller' | 'blackFriday' | 'fastShipping';
export const FLAGS_TYPES_NAMES: Record<TFlagsNames, TProductFlagsKey> = {
  publication: 'PUBLICATION',
  testPublication: 'PUBLICATION_TEST',
  assembly: 'ASSEMBLY',
  novelty: 'NEW',
  noveltyDate: 'NEW_TIL',
  availability: 'SHOP_ENABLE',
  deliveryBehaviour: 'BEHAVIOUR_DELIVERY',
  hotSale: 'HOT_SALE',
  hotSaleDate: 'HOT_SALE_TIL',
  goodSale: 'GOOD_END',
  surpriseSale: 'SURPRISE',
  bestseller: 'BESTSELLER',
  blackFriday: 'BLACK_FRIDAY',
  fastShipping: 'FAST_SHIPPING'
};